import React, { useState } from 'react';
import { useDropzone } from 'react-dropzone';
import useFeature from "../../../useFeature";
import { OrderTicketsManagementFeature } from "./OrderTicketsManagementFeature";
import { observer } from "mobx-react";
import { HOME_PATH } from "../../../routes";
import { useNavigate } from "react-router-dom";
import successToast from "../../../components/toast/SuccessToast";
import { useApplication } from "../../../ApplicationProvider";
import ArticleIcon from '@mui/icons-material/Article';

const OrderTicketsManagementScreen = ({ section }) => {
    const application = useApplication();
    const feature = useFeature(() => new OrderTicketsManagementFeature(application));
    const navigator = useNavigate();

    const isFeatureReady = (feature) => {
        return feature && feature.loaded;
    };

    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [issue, setIssue] = useState("Otro");
    const [detail, setDetail] = useState("");
    const [files, setFiles] = useState([]);
    const [error, setError] = useState("");

    const ticketOptions = [
        { id: "Contacto por Cliente", label: "Contacto por Cliente" },
        { id: "Informar Pago", label: "Informar Pago" },
        { id: "Problema con la Entrega", label: "Problema con la Entrega" },
        { id: "Problema con la Factura", label: "Problema con la Factura" },
        { id: "Problemas con el Producto", label: "Problemas con el Producto" },
        { id: "Problemas con la Tienda", label: "Problemas con la Tienda" },
        { id: "Otro", label: "Otro" }
    ];

    const acceptedFileTypes = '.pdf,.jpg,.jpeg,.png,.docx,.xlsx';

    const handleDrop = (acceptedFiles, rejectedFiles) => {
        if (rejectedFiles.length > 0) {
            setError(`Solo se permiten archivos con las extensiones: ${acceptedFileTypes}`);
        } else {
            setError("");
            setFiles(acceptedFiles);
        }
    };

    const { getRootProps, getInputProps } = useDropzone({
        onDrop: handleDrop,
        multiple: true,
        accept: acceptedFileTypes,
        name: 'files[]',
        type: 'file',
    });

    const canAddTicket = () => {
        return name !== "" && email !== "" && issue !== "" && detail !== "";
    };

    return isFeatureReady(feature) && (
        <div>
            <div className="container">
                <div className="row">
                    <div>
                        <div className="p-5 shadow bg-white rounded" style={{
                            maxWidth: "600px",
                            margin: "auto",
                            display: "flex",
                            flexDirection: "column",
                            gap: "1em"
                        }}>
                            <h3 className="text-center mb-4">Nueva Solicitud</h3>

                            <div className="mb-4 text-start">
                                <p className="general-title">Nombre</p>
                                <input
                                    type="text"
                                    className="form-control"
                                    id="nombre"
                                    value={name}
                                    onChange={(e) => setName(e.target.value)}
                                    placeholder="Ingrese su nombre"
                                    style={{
                                        width: "100%",
                                        padding: "10px",
                                        borderRadius: "5px",
                                        border: "1px solid #ced4da",
                                        backgroundColor: "#fff",
                                        fontSize: "16px",
                                    }}
                                />
                            </div>

                            <div className="mb-4 text-start">
                                <p className="general-title">Email</p>
                                <input
                                    type="email"
                                    className="form-control"
                                    id="email"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    placeholder="Ingrese su email"
                                    style={{
                                        width: "100%",
                                        padding: "10px",
                                        borderRadius: "5px",
                                        border: "1px solid #ced4da",
                                        backgroundColor: "#fff",
                                        fontSize: "16px",
                                    }}
                                />
                            </div>

                            <div className="mb-4 text-start">
                                <p className="general-title">Tipo de ticket</p>
                                <select className="form-select"
                                        value={issue}
                                        onChange={(e) => setIssue(e.target.value)}
                                        style={{
                                            width: "100%",
                                            padding: "10px",
                                            borderRadius: "5px",
                                            border: "1px solid #ced4da",
                                            backgroundColor: "#fff",
                                            fontSize: "16px",
                                        }} id="tiporeclamo">
                                    {ticketOptions.map(option => (
                                        <option key={option.id} value={option.id}>{option.label}</option>
                                    ))}
                                </select>
                            </div>

                            <div className="mb-4 text-start">
                                <p className="general-title">Detalle</p>
                                <textarea className="form-control" id="num-pedido" maxLength="2048"
                                          placeholder="Ingrese sus observaciones" rows="3"
                                          value={detail}
                                          onChange={(e) => setDetail(e.target.value)}></textarea>
                            </div>

                            <div className="mb-4 text-start">
                                <p className="general-title">Adjuntar Documentos</p>
                                <div
                                    {...getRootProps()}
                                    style={{
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        border: "1px solid #ced4da",
                                        borderRadius: "5px",
                                        padding: "20px",
                                        backgroundColor: "#f8f9fa",
                                        cursor: "pointer",
                                        marginBottom: "1em",
                                        width: "100%",
                                    }}
                                >
                                    <input {...getInputProps()} accept={acceptedFileTypes} />
                                    <button
                                        style={{
                                            backgroundColor: "transparent",
                                            border: "none",
                                            color: "#007bff",
                                            cursor: "pointer",
                                            padding: "5px 10px",
                                            fontSize: "16px",
                                            marginRight: "10px",
                                        }}
                                    >
                                        <ArticleIcon sx={{ color: 'gray' }} />
                                    </button>
                                    <span>
                                        {files.length > 0 ? `${files.length} archivo(s) seleccionado(s)` : "Ningún archivo seleccionado"}
                                    </span>
                                </div>

                                {error && <div style={{ color: "red", fontSize: "14px", marginTop: "10px" }}>{error}</div>}

                                {files.length > 0 && (
                                    <div style={{ paddingLeft: "1em", fontSize: "14px" }}>
                                        <ul style={{ listStyleType: "none", padding: 0 }}>
                                            {Array.from(files).map((file, index) => (
                                                <li key={index} style={{ marginBottom: "0.5em" }}>
                                                    {file.name}
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                )}
                            </div>

                            <div style={{ display: "flex", gap: "1em", justifyContent: "center" }}>
                                <button className={`btn w-50 me-2 ${!canAddTicket() ? "btn-primary-disabled" : "btn-primary"}`} disabled={!canAddTicket()}
                                        onClick={() => {
                                            feature.addTicket(name, email, issue, detail, files, () => {
                                                navigator(HOME_PATH)
                                                successToast("La solicitud ha sido enviada correctamente.")
                                            })
                                        }}>
                                    Enviar
                                </button>
                                <button className="btn btn-secondary w-50" onClick={() => {
                                    navigator(HOME_PATH)
                                }}>Cancelar
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default observer(OrderTicketsManagementScreen);
